module.exports = __webpack_public_path__ + "static/img/logo.8bf160b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = ZBJ4
// module chunks = 1